<template>
    <div class="container">
        <TitleInfo title="服务模版" :tip="tip1"  v-if="classListInfo.ownTotal"></TitleInfo>
        <div class="items">
            <ProdBookItem :items="classListInfo.results" v-if="!$router.currentRoute.query.keyword"/>
            <ClassSearchResult :items="classListInfo.results" v-if="$router.currentRoute.query.keyword"/>
            <Empty v-if="!classListInfo.ownTotal&&!loading"/>
        </div>
        <Page :total="classListInfo.ownTotal"
              v-if="classListInfo.ownTotal"
              :current="filterParams.pageIndex*1"
              :page-size="filterParams.pageSize"
              @on-change="handlePageIndexChanged"/>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
    import api from '@/api/calss-search'
    import ProdBookItem from "../components/ProdBookItem";
    import ClassSearchResult from "../components/ClassSearchResult";
    import Empty from "../../class-search-result/empty"
    import TitleInfo from "../components/TitleInfo";

    export default {
        name: "CorporateTemplateCourse",
        data() {
            return {
                tip1:'该库汇集行业中为客户制作的常用手册，包括但不限于《指南手册》《报价文件》 《诉讼策略报告 》《服务报告》等模板，不仅有专家团队的最佳实践示范，而且有精美的设计排版。',
                loading:false,
                filterParams: {
                    query: this.$router.currentRoute.query.keyword,
                    pageIndex: this.$router.currentRoute.query.pageIndex||1,
                    pageSize: 6,
                    searchNumberType:1,
                    searchType: 'productManual',
                    secondType:'corporateTemplate'
                },
                classListInfo:{
                    results:[],
                    courseTotal:0,
                    moduleNumbers:{}
                },
                totalCount: 0,
                searchTitle: '',
                pageIndex: 0,
                courses: []
            }
        },
        watch: {
            $route(to, from) {
                this.filterParams.query = this.$router.currentRoute.query.keyword
                this.filterParams.pageIndex = this.$router.currentRoute.query.pageIndex||1
                this.filterParams.pageSize = 6
                this.queryList()
            }
        },
        components: {ProdBookItem,Empty,ClassSearchResult,TitleInfo},
        methods: {
            // 查询数据
            async queryList() {
                this.loading = true
                api.classSearchList(this.filterParams).then(res => {
                    this.loading = false
                    this.classListInfo = res
                }).finally(() => {
                    this.loading = false
                })
            },
            handlePageIndexChanged(index) {
                this.filterParams.pageIndex = index;
                this.$router.push(`${this.$router.currentRoute.path}?keyword=${this.$router.currentRoute.query.keyword||''}&pageIndex=${index}`)
            }
        },
        mounted() {
            this.queryList();
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped lang="scss">
    .container {
        width: 942px;
        padding: 40px 0px 40px 0px;
        margin: auto;
        margin-left: 45px;
    }

    .totalCount {
        height: 20px;
        margin-left: 10px;
        font-family: PingFangSC;
        font-size: 14px;
        margin-bottom: 32px;
        color: #4a4a4a;
    }
    .items{
        overflow: hidden;
        margin-bottom: 20px;
    }
    .pagination {
        clear: both;
    }
</style>
